
























































/** Временный пароль приходит только в ответе на сброс, повторно получить его неоткуда */
import { Component, Mixins, Prop } from 'vue-property-decorator';

import Toast from '@/mixins/toast';

import { copyTextToClipboard } from '../../core/download';
import { orDash } from '../../core/format';
import { MmAuditor } from '../../types/domain';
import AuditorMessengerSendMixin from './auditorMessengerSendMixin';

const KEY = 'priceMonitoring.mobileMonitoring.auditors.';

@Component
export default class AuditorPasswordResetModal extends Mixins(Toast, AuditorMessengerSendMixin) {
	@Prop({ default: false }) readonly visible!: boolean;

	@Prop({ default: null }) readonly auditor!: MmAuditor | null;

	@Prop({ default: null }) readonly tempPassword!: string | null;

	get temporaryPassword(): string {
		const value = this.tempPassword !== null && this.tempPassword !== undefined
			? String(this.tempPassword)
			: '';

		return value.trim() === '' ? '' : value;
	}

	get hasPassword(): boolean {
		return this.temporaryPassword !== '';
	}

	get passwordDisplay(): string {
		return orDash(this.temporaryPassword);
	}

	get auditorLogin(): string {
		return orDash(this.auditor !== null && this.auditor !== undefined ? this.auditor.login : null);
	}

	get messengerSendLogin(): string {
		const auditor = this.auditor;

		return auditor !== null && auditor !== undefined && auditor.login
			? String(auditor.login)
			: '';
	}

	get messengerSendPassword(): string {
		return this.temporaryPassword;
	}

	get messengerSendMessengers() {
		const auditor = this.auditor;

		return auditor !== null && auditor !== undefined ? auditor.messengers : null;
	}

	get messengerSendPhone(): string | null {
		const auditor = this.auditor;

		return auditor !== null && auditor !== undefined ? auditor.phone : null;
	}

	get modalTitle(): string {
		return this.$t(KEY + 'resetPasswordDoneTitle') as string;
	}

	get introText(): string {
		return this.$t(KEY + 'resetPasswordDoneText') as string;
	}

	get loginLabel(): string {
		return this.$t(KEY + 'fieldLogin') as string;
	}

	get passwordOnceText(): string {
		return this.$t(KEY + 'tempPasswordOnce') as string;
	}

	get passwordCopyText(): string {
		return this.$t(KEY + 'tempPasswordCopy') as string;
	}

	get closeText(): string {
		return this.$t('shared.actions.close') as string;
	}

	copyPassword(): void {
		if (!this.hasPassword) {
			return;
		}

		if (copyTextToClipboard(this.temporaryPassword)) {
			this.showInfo(this.$t(KEY + 'tempPasswordCopied') as string);
		}
	}

	handleCancel(): void {
		this.$emit('cancel');
	}
}
